import { defineAction } from '~/prix'
import actionJson from './roadMaintenanceDocumentDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import roadMaintenanceDocumentObject from '../roadMaintenanceDocumentObject'

const definition = defineAction({
  ...actionJson,
  input: z.object({ id: roadMaintenanceDocumentObject.shape.id }),
  output: z.object({}),
})

export default definition
